export enum ApplicationEventPriceFilterInteractionType {
  InputMin = 'price input min',
  InputMax = 'price input max',
  SliderMin = 'price slider min',
  SliderMax = 'price slider max',
}
